import { type ExportHeaderNameMode } from './exportListPersonsToCsv'

export const PINNED_ATTRIBUTE_KEY = '_id'

export const EXPORT_STEP_COUNT = 4
export const EXPORT_MODE_STEP = 0
export const SELECT_COLUMNS_STEP = 1
export const REVIEW_STEP = 2
export const EXPORT_STEP = 3

export const REVIEW_PREVIEW_TRANSITION_MS = 900
export const REVIEW_PREVIEW_TRANSITION_DURATION = `${REVIEW_PREVIEW_TRANSITION_MS}ms`

export const DEFAULT_EXPORT_HEADER_NAME_MODE: ExportHeaderNameMode = 'readable'
